import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import RecommendedSection from './components/RecommendedSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '香香漫画 - 韩国漫画免费阅读 - 在线看韩漫官网 - 下拉式韩漫大全';
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotSection />
        <RecommendedSection />
        <RankingSection />
        <FeaturesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}